import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [logoSrc, setLogoSrc] = useState('/logonew.png');
  return (
    <footer className="footer full-width-section">
      <div className="footer-full-width">
        <div className="section-container">
          <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo">
              <img
                src={logoSrc}
                onError={() => setLogoSrc('/logo.png')}
                alt="Ambreen Daudpota - Advocate High Court"
                className="footer-logo-image"
                loading="lazy"
                decoding="async"
              />
            </Link>
            <p className="footer-description">
              Providing professional legal services with integrity, dedication, and years of experience in the judicial system.
            </p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/practice-areas">Practice Areas</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Legal Services</h4>
            <ul>
              <li>Civil Litigation</li>
              <li>Criminal Defense</li>
              <li>Family Law</li>
              <li>Corporate Law</li>
              <li>Property Law</li>
              <li>Legal Consultation</li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <span className="contact-text">0333-7125176</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <span className="contact-text">ambreendaudpota@gmail.com</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span className="contact-text">Quresh Law Chamber<br />Station Road Sukkur</span>
              </div>
            </div>
          </div>
        </div>
        
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p>&copy; 2025 <a href="https://clouddevnest.com" target="_blank" rel="noopener noreferrer">ClouDevNest</a>. All rights reserved.</p>
              <p>Software Solution Provider</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
